
export class CreditCard {
	constructor(card = {}) {
		this.cardNumber = card.cardNumber || undefined;
		this.brandId = card.brandId;
		this.holder = card.holder || undefined;
		this.securityCode = card.securityCode || undefined;
		this.expirationDate = card.expirationDate || undefined;
	}
}

export class Address {
	constructor(address = {}) {
		this.street = address.street || undefined;
		this.district = address.district || undefined;
		this.number = address.number || undefined;
		this.complement = address.complement || undefined;
		this.zipCode = address.zipCode || undefined;
		this.city = address.city || undefined;
		this.state = address.state || undefined;
		this.uf = address.uf || undefined;
		this.countryId = address.countryId || undefined;
	}
}

class Customer {
	constructor(customer = {}) {
		this.name = customer.name || undefined;
		//this.email = customer.email || undefined;
		//this.phone = customer.phone || undefined;
		//this.birthDate = customer.birthDate || undefined;
		this.identity = customer.identity || undefined;
		this.inscriptionTypeId = customer.inscriptionTypeId;
		this.address = new Address(customer.address || {});
	}
}

class Payment {
	constructor(payment = {}) {withFraudAnalysis
		this.amount = payment.amount || undefined;
		this.installments = payment.installments || undefined;
		this.creditCard = new CreditCard(payment.creditCard || {});
	}
}


export default class Sale {
	constructor() {
		this.chargingLinkCode = undefined;
    this.companyId = undefined;
		this.customer = new Customer();
		this.creditCard = new CreditCard();
    this.amount = undefined;
    this.installments = undefined;
    this.fileNumber = undefined;
		this.observation = undefined;
		this.optional = false;
  }

  static fromChargingLink(chargingLink) {
    let sale = new Sale();
    sale.chargingLinkCode = chargingLink.code;
		sale.companyId = chargingLink.company.id;
		sale.customer.name = chargingLink.name;
		sale.customer.address.countryId = chargingLink.country.id;
		sale.fileNumber = chargingLink.file.fileNumber;
		sale.bookingId = chargingLink.bookingId;
		sale.roomId = chargingLink.roomId;
		sale.amount = chargingLink.amount;
		sale.observation = chargingLink.observation;
		sale.optional = chargingLink.optional;
		return sale;
  }

  withFraudAnalysis(fingerPrintId) {
    this.fraudAnalysis = {
			fingerPrintId,
			browserCookiesAccepted: false
		};
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/models/Sale.js